import React, { useState, useEffect } from 'react'
import { selectPickGameTimer, setPickGameTimer } from '../../../redux/3d_game_Slice/gameinfo3d'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { selectLoaderShow } from '../../../redux/seriesSlice'
import { resetPanel } from '../../../redux/3d_game_Slice/panelSlice'

function TimeLeft3d() {
  const dispatch = useDispatch()
  const secondTimer = useSelector(selectPickGameTimer)
  const loaderShow = useSelector(selectLoaderShow)
  const [secondDiffShow, setSecondDiffShow] = useState(null)

  let getTime = (endTime) => {
    let startTime = moment()
    var secondsDiff = endTime.diff(startTime, 'seconds');
    if (secondsDiff === 0) {
      dispatch(dispatch(setPickGameTimer(0)))
      dispatch(resetPanel());
    }
    setSecondDiffShow(secondsDiff)
  }

  useEffect(() => {
    if (!secondTimer) {
      return
    }
    let endTime = moment()
    endTime.add(secondTimer, 'seconds')
      .format('LTS');
    let interval = setInterval(() => {
      getTime(endTime)
    }, 1000);

    return () => clearInterval(interval);
  }, [secondTimer]);



  return (
    <>{secondDiffShow ? moment.utc(secondDiffShow * 1000).format('mm:ss') : '00:00'}</>
  )
}

export default TimeLeft3d